import { render, staticRenderFns } from "./PrintparcelinformationReceive.vue?vue&type=template&id=36eaf45c&scoped=true&"
import script from "./PrintparcelinformationReceive.vue?vue&type=script&lang=js&"
export * from "./PrintparcelinformationReceive.vue?vue&type=script&lang=js&"
import style0 from "./PrintparcelinformationReceive.vue?vue&type=style&index=0&id=36eaf45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eaf45c",
  null
  
)

export default component.exports